import React, { Dispatch, MouseEvent, MutableRefObject, SetStateAction, useEffect, useRef, useState } from 'react'
import Switch from './Switch'
import { VoiceCommandCloseIcon } from './IconSet'
import { WeatherAssistantServiceClient } from '../../services/proto/chatProto/WeatherAssistantProtoServiceClientPb'
import { ChatHistoryDeleteRequest, ChatRequest, ChatResponse, EmptyResponse } from '../../services/proto/chatProto/weatherAssistantProto_pb'

import ChatIconLoading from "../../assets/chat-load.gif"
import { StatusCode } from 'grpc-web'


type VoiceTerminalPropsTypes = {
    setTerminalState: Dispatch<SetStateAction<boolean>>
    voiceCommand: string
    easyAccessCommand: string
    setEasyAccessCommand?: Dispatch<React.SetStateAction<string>>
    //setCommands: Dispatch<SetStateAction<string[]>>
    //commands: string[]
}

type RoleType = "user" | "assistant" | "load"

type ChatType = {
    role: RoleType;
    message: string;
}

// Weather assistant URL
const WEATHER_ASSISTANT_URL: string = "http://107.21.76.41:8080"

export var chatId: string = ""

const VoiceTerminal = (props: VoiceTerminalPropsTypes) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false)
    // Text / voice button
    const [buttonState, setButtonState] = useState<boolean>(true)
    // Chat history
    const [chatHistory, setChatHistory] = useState<ChatType[]>([])

    // Text box
    const textRef = useRef<HTMLInputElement>(null)
    // Text body
    const textBodyRef = useRef<HTMLDivElement>(null)
    
    // Add message to chat history
    const addMessageToHistory = (role: RoleType, message: string) => {
        setChatHistory(prevState => [...prevState, {role: role, message: message}])
        if (!buttonState && role === "assistant") {
            speak(message)
        }
    }

    // Remove load role from history
    const removeLoadRole = () => {
        setChatHistory(prevState => prevState.filter(chat => chat.role !== "load"))
    }

    // Send request
    const sendMessage = async (message: string) => {
        // Set loading message
        setIsProcessing(true)
        addMessageToHistory("load", "")
        try {
            const client = new WeatherAssistantServiceClient(WEATHER_ASSISTANT_URL, null, {
                deadline: Date.now() + 60000 * 10
            })
            const request = new ChatRequest();
            request.setConversationId(chatId);
            request.setMessage(message);
            
           // Send gRPC request (/chat)
            const response: ChatResponse = await new Promise((resolve, reject) => {
                
                client.chat(request, {}, (err, response) => {
                    if (err) {
                        if (err.code !== StatusCode.OK) {
                            // Remove loading message
                            removeLoadRole()
                            addMessageToHistory("assistant", "Ops... Something is wrong 😬")
                        }
                        return reject(err);
                    }
                    resolve(response);
                });
            });

            console.log("Response:", response.getReply());
            
            // Remove loading message
            removeLoadRole()
            setIsProcessing(false)
            addMessageToHistory("assistant", response.getReply())
            
            // Set chat id
            chatId = response.getConversationId()
            setIsProcessing(false)
            console.log(">>>>>> step 2 OK")
            console.log(">>>>>> step 2 ", isProcessing)
        }
        catch (error) {
            console.error("Error in sendMessage:", error);
            addMessageToHistory("assistant", "Sorry, I can not connect my server right now 🤔")
            console.log(">>>>>> step 2 OK")
            setIsProcessing(false)
        }
    }

    // Delete chat history request
    const sendDeleteChatHistory = async (chatId: string) => {
        try {
            const client = new WeatherAssistantServiceClient(WEATHER_ASSISTANT_URL, null, {
                deadline: Date.now() + 60000 * 10
            })
            const request = new ChatHistoryDeleteRequest();
            request.setConversationId(chatId);
            
           // Send gRPC request (/chat)
            const response: EmptyResponse = await new Promise((resolve, reject) => {
                
                client.chatHistoryDelete(request, {}, (err, response) => {
                    if (err) {
                        if (err.code !== StatusCode.OK) {
                            console.log("Chat deleted successfully")
                        }
                        return reject(err);
                    }
                    resolve(response);
                });
            });
            console.log(response)
        }
        catch (error) {
            console.error("Error in sendMessage:", error);
        }
    }

    // Text to speak
    const speak = (text: string) => {
        setIsProcessing(true)
        if ('speechSynthesis' in window) {
            const utterance = new SpeechSynthesisUtterance(text);
            
            // voice settings
            utterance.rate = 1; // Speed (0.1 to 10)
            utterance.pitch = 1; // Pitch (0 to 2)
            utterance.volume = 1; // Volume (0 to 1)
            
            // Select a specific voice
            const voices = window.speechSynthesis.getVoices();
            if (voices.length > 0) {

                const preferredVoice = voices.find(voice => 
                    voice.name.includes('Google') || voice.lang.includes('en-US')
                );
                if (preferredVoice) {
                    utterance.voice = preferredVoice;
                }
            }
            
            window.speechSynthesis.speak(utterance);
            
            // Handle events
            utterance.onend = () => {
                console.log('Speech finished')
                setIsProcessing(false)
            };
            utterance.onerror = (event) => console.error('Speech error:', event);
        } else {
            console.warn('Speech synthesis not supported in this browser');
        }
    };
    
    // Handle click send button
    const handleClickSendButton = () => {
        if (textRef.current) {
            const value = textRef.current.value.trim()
            if (value !== "") {
                addMessageToHistory("user", value)
                textRef.current.value = ""
                sendMessage(value)
            }
        }
    }

    /* const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null; */

    useEffect(() => {
        if (textBodyRef.current) {
            textBodyRef.current.scrollTop = textBodyRef.current.scrollHeight
        }
    })

    /* useEffect(() => {
        if (!recognition) return;
    
        if (!buttonState) {
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.lang = 'en-US';
    
            recognition.onresult = (event: any) => {
                let finalTranscript = '';
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    const result = event.results[i];
                    if (result.isFinal) {
                        finalTranscript += result[0].transcript + ' ';
                    }
                }
    
                if (finalTranscript.trim()) {
                    setChatHistory(prev => [...prev, { role: 'user', message: finalTranscript.trim() }]);
                    sendMessage(finalTranscript.trim())
                }
            };
    
            recognition.onerror = (event: any) => {
                console.error('Speech recognition error:', event.error);
                if (event.error === 'network' || event.error === 'not-allowed') {
                    recognition.stop();
                }
            };
    
            recognition.onend = () => {
                console.log('Recognition ended');
                if (!buttonState) {
                    try {
                        recognition.start(); // restart if still in voice mode
                    } catch (e) {
                        console.error('Restart failed:', e);
                    }
                }
            };
    
            try {
                recognition.start();
            } catch (e) {
                console.error('Recognition start failed:', e);
            }
        } else {
            // STOP recognition when switched to text mode
            try {
                recognition.stop();
                recognition.onend = null; // prevent auto-restart
                console.log('Voice recognition stopped due to buttonState change');
            } catch (e) {
                console.error('Recognition stop failed:', e);
            }
        }
    
        return () => {
            try {
                recognition.stop();
                recognition.onend = null;
            } catch (e) {
                console.error('Cleanup stop failed:', e);
            }
        };
    }, [buttonState]); */

    useEffect(() => {
        if (!buttonState) {
            console.log("VoiceCommandComp Command: ", props.voiceCommand)
            addMessageToHistory("user", props.voiceCommand)
            sendMessage(props.voiceCommand)
        }
    }, [props.voiceCommand])

    useEffect(() => {
        if(props.easyAccessCommand !== "" && !isProcessing) {
            setChatHistory(prevState => [...prevState, {role: "user", message: props.easyAccessCommand}])
        }
    }, [props.easyAccessCommand])

    return (
        <div className={`voice-terminal-wrapper`}>
            <div className={`title-section`}>
                <div className={`left-side`}>
                    <span className={`title`}>Eagle-I Assistant</span>
                </div>
                <div className={`right-side`}>
                    <div className={`icon`} onClick={(e) => {
                        props.setTerminalState(false)
                        sendDeleteChatHistory(chatId)
                    }}>
                        <VoiceCommandCloseIcon size='1rem' color='var(--text-color)'/>
                    </div>
                </div>
            </div>
            <div className={`type-selector-section`}>
                <Switch buttonState={buttonState} setButtonState={setButtonState}/>
            </div>
            <div className={`terminal-body-section`} ref={textBodyRef}>
                {chatHistory.map((chat, index) => (
                    chat.role === "user" ? (
                        <div key={index} className='message-wrapper user'>
                            <div className='pro-pic'>
                                
                            </div>
                            <span>{chat.message}</span>
                        </div>
                    ) : chat.role === "assistant" ? (
                        <div key={index} className='message-wrapper assistant'>
                            <span>{chat.message}</span>
                            <div className='pro-pic'></div>       
                        </div>
                    ) : chat.role === "load" ? (
                        <div key={index} className='message-wrapper load'>
                            <span><img src={ChatIconLoading} alt="" /></span>
                            <div className='pro-pic'></div>         
                        </div>
                    ) : null
                ))}
            </div>
            {buttonState && (
                <div className={`input-section`}>
                    <input type="text" ref={textRef} placeholder='Enter command here'/>
                    <button onClick={(e) => {
                        handleClickSendButton()
                    }} type="button" disabled={isProcessing}>send</button>
                </div>
                
            )}
        </div>
    )
}

export default VoiceTerminal